import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Switch } from 'react-router-dom';

const Comercial = asyncComponent(() => import('../comercial'));
const ListaProspect = asyncComponent(() =>
  import('../comercial/CadastroProspect')
);
const CadastroProspect = asyncComponent(() =>
  import('../comercial/CadastroProspect/DadosProspect')
);
const ListaOcorrenciaProspects = asyncComponent(() =>
  import('../comercial/HistoricoOcorrencia')
);
const AgendaComercial = asyncComponent(() =>
  import('../comercial/AgendaComercial')
);
const StatusProspects = asyncComponent(() =>
  import('../comercial/StatusProspects')
);
const PerfilProspects = asyncComponent(() =>
  import('../comercial/PerfilProspects')
);
const MotivoCartaoKanban = asyncComponent(() =>
  import('../comercial/MotivoConclusaoCartaoKanban')
);
const Kanban = asyncComponent(() => import('../comercial/Kanban/kanban'));
const Quadros = asyncComponent(() => import('../comercial/Kanban/index'));
const RelConclusaoCartaoKanban = asyncComponent(() =>
  import('../comercial/Kanban/relatorio/CartoesConcluidos')
);
const ImportacaoProspects = asyncComponent(() =>
  import('../comercial/Ferramentas/importacao')
);

export default function ComercialRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/com/prospect/:id`}
          component={CadastroProspect}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/prospect/`}
          component={CadastroProspect}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/prospects`}
          component={ListaProspect}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/historico-ocorrencia`}
          component={ListaOcorrenciaProspects}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/agenda-comercial`}
          component={AgendaComercial}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/status-prospects`}
          component={StatusProspects}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/perfil-prospects`}
          component={PerfilProspects}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/motivo-conclusao-kanban`}
          component={MotivoCartaoKanban}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/kanban/:id`}
          component={Kanban}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/kanban`}
          component={Quadros}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/rel-kanban-conclusao-cartoes`}
          component={RelConclusaoCartaoKanban}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/inicio`}
          component={Comercial}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          path={`${match.url}/com/prospects-importacoes`}
          component={ImportacaoProspects}
          codigo="modulo_comercial"
        />
        <PrivateRoute
          exact
          path={`${match.url}/com`}
          component={Comercial}
          codigo="modulo_comercial"
        />
      </Switch>
    </>
  );
}
